module.exports = __webpack_public_path__ + "img/bg-blog.4db01826.png";